import React, { useCallback, useRef } from 'react'
import { Grid } from '@material-ui/core'
import AdminPage from '../shared/AdminPage'
import { useHideSideMenuEffect } from '../../../../redux/slices/appContext'
import FlexRow from '../../../molecules/FlexRow'
import SydButton from '../../../commonDesign/Button'

const hues = ['primary', 'secondary', 'accent', 'neutral', 'surface', 'texture', 'success', 'info', 'warning', 'danger', 'growth', 'decline']
const shades = ['050', '100', '200', '300', '400', '500', '600', '700', '800', '900']
const other = [
  '--root-color', '--root-color-contrast', '--root-bg-color', '--text-color-main',
  '--theme-color-surface-d0', '--theme-color-surface-d1', '--theme-color-surface-d2', '--theme-color-surface-d3', '--theme-color-surface-d4',
  '--theme-color-text-primary'
]

function ThemeHome () {
  useHideSideMenuEffect([])
  const sheetRef = useRef(null)
  const setVars = useCallback(() => {
    const text = sheetRef.current.value
    const json = JSON.parse(text)
    if (Array.isArray(json)) {
      json.forEach(item => {
        document.documentElement.style.setProperty(item.key, item.value)
      })
    }
  }, [sheetRef])

  return (
    <AdminPage>
      <Grid container spacing={1}>
        <Grid item xs={4}>
          <Grid container spacing={2}>
            {hues.map(hue => (
              shades.map(shade => (
                <Grid item xs={12} key={`${hue}-${shade}`}>
                  <FlexRow>
                    <div>{hue}-{shade}</div>
                    <span style={{ minHeight: '32px', minWidth: '100px', backgroundColor: `var(--color-${hue}-${shade})`, border: 'var(--border-neutral-thin)' }}>&nbsp;</span>
                    <span style={{ minHeight: '32px', minWidth: '100px', backgroundColor: `var(--color-${hue}-${shade})`, color: `var(--color-contrast-${hue}-${shade})`, border: 'var(--border-neutral-thin)' }}>Contrast</span>
                  </FlexRow>
                </Grid>
              ))
            ))}
            {other.map(o => (
              <Grid item xs={12} key={`_${o}`}>
                <FlexRow>
                  <div>{o}</div>
                  <span style={{ minHeight: '32px', minWidth: '100px', backgroundColor: `var(${o})`, border: 'var(--border-neutral-thin)' }}>&nbsp;</span>
                </FlexRow>
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid item xs={8}>
          <SydButton size='sm' onClick={setVars}>Recalculate</SydButton>
          <textarea ref={sheetRef} style={{ width: '100%', height: '100%', border: 'var(--border-neutral-thin)' }} />
        </Grid>
      </Grid>
    </AdminPage>
  )
}

export default ThemeHome
